import React from "react";

interface ICommentLinkSplitService {
  getRegexForLink(): RegExp;
  getMatchEndIndex(match: string, index: number): number;
  getLinkDisplay(text: string): JSX.Element;
}
class CommentLinkSplitService implements ICommentLinkSplitService {
  getRegexForLink = () => {
    // eslint-disable-next-line no-control-regex
    return RegExp("((https?://)(www.)|(https?://)|(www.))[\\w\\d.]{2,256}[.][a-z]{2,6}[\\S]*", "g");
  };

  getMatchEndIndex = (match: string, index: number) => {
    return index + match.length;
  };

  getLinkDisplay = (text: string) => {
    const matches = text.match(this.getRegexForLink());

    if (matches) {
      const matchIndices: number[] = [];
      matches.map(match => matchIndices.push(text.indexOf(match)));
      const indexFirstMatch = matchIndices[0];

      return (
        <span>
          {text.substring(0, indexFirstMatch)}
          {matches.map((match, index) => {
            let afterString = "";
            if (index < matches.length - 1) {
              afterString = text.substring(
                this.getMatchEndIndex(match, matchIndices[index]),
                matchIndices[index + 1]
              );
            } else {
              afterString = text.substring(this.getMatchEndIndex(match, matchIndices[index]));
            }
            return (
              <span>
                <a href={match}>{match}</a>
                {afterString}
              </span>
            );
          })}
        </span>
      );
    }
    return <span>{text}</span>;
  };
}

export const commentLinkSplitService: ICommentLinkSplitService = new CommentLinkSplitService();
